import { createAccessTokenForUri, hostname } from '@/api/client';

interface PopsProxyRequest {
  url: string;
  method?: string;
  headers?: Record<string, string>;
  body?: string;
}

export function transformPopsProxyRequest<T extends PopsProxyRequest>(req: T): T {
  const parsed = new URL(req.url, window.location.origin);
  let path = parsed.pathname;

  path = path.replace(/^\/v1\/publications\/([^/]+)\/interactions\//, '/v1/publication/pops/$1/interactions/');
  path = path.replace(/^\/v1\/sessions/, '/v1/publication/pops/sessions');

  const requestUri = path + parsed.search;
  const url = hostname + requestUri;

  // normalize incoming headers to lowercase keys to avoid duplicates (e.g. X-AccessToken vs x-accesstoken)
  const headers: Record<string, string> = {};
  for (const [key, value] of Object.entries(req.headers ?? {})) {
    headers[key.toLowerCase()] = value;
  }

  // promote the POPS-issued session token to a separate header before re-signing the outer request
  if (headers['x-accesstoken']) {
    headers['x-pops-accesstoken'] = headers['x-accesstoken'];
    delete headers['x-accesstoken'];
  }

  // signed as-is since it is the exact string POPS sends
  const accessToken = createAccessTokenForUri(req.method ?? 'GET', requestUri, req.body);
  if (!accessToken) {
    // no LEAD session — fail loudly rather than sending an unsigned request that will 401
    throw new Error(`POPS proxy: no LEAD session available to sign request for ${requestUri}`);
  }
  headers['x-accesstoken'] = accessToken;

  return { ...req, url, headers };
}
